import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
	standalone: true,
	imports: [CommonModule, MatDialogModule, MatIconModule],
	template: `
		<h2 mat-dialog-title>Can't connect...</h2>
		<mat-dialog-content>
			<div class="wrapper">
				<mat-icon class="spin-slow">sync_problem</mat-icon>
				Please check your network/internet connection.
			</div>
		</mat-dialog-content>
	`,
	styles: [
		`
			@import 'theme-variables';

			:host {
				display: block;

				mat-dialog-content {
					overflow: hidden;
				}

				.wrapper {
					display: flex;
					align-items: center;

					mat-icon {
						margin-right: 0.25rem;
						zoom: 120%;
						color: $warn;
					}
				}
			}
		`,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineStatusComponent {}
